import { useACL } from "layouts/agent/agent-info/agent-acl/_context/AgentACLContext";
import SearchTableUsersACL from "./components/SearchTableUsersACL";
import Card from "components/card";

const UserACLDatatable = () => {
  const { aclUsers } = useACL();
  return (
    <Card extra={"w-full h-full mt-3"}>
      <SearchTableUsersACL tableData={aclUsers} />
    </Card>
  );
};

export default UserACLDatatable;
